import React, { useState } from 'react';
import styled from './styled';
import Icon from './Icon';
import { FlexStyle } from '../web/react-native';

import PressableWithOpacity from './PressableWithOpacity';
import RowTitle from './RowTitle';

interface AccordionProps {
  title: string;
  size: number;
  children?: React.ReactNode;
  style?: FlexStyle;
  disabled?: boolean;
  expanded?: boolean;
  header?: (expanded: boolean, canCollapse: boolean) => React.ReactNode;
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  size,
  children,
  style,
  disabled = false,
  expanded = false,
  header,
}) => {
  const [expand, setExpand] = useState(expanded);
  const canCollapse = size > 1;

  const defaultHeader = (
    <>
      <RowTitle title={title} />
      {canCollapse && (
        <ExpandIcon
          name={expand ? 'chevron-up' : 'chevron-down'}
          size={20}
          color={disabled ? '#ccc' : '#00A3E0'}
        />
      )}
    </>
  );

  return (
    <Container expanded={expand} canCollapse={canCollapse} style={style}>
      {canCollapse && (
        <HeaderContainer
          onPress={() => {
            if (canCollapse) {
              setExpand((previousState) => !previousState);
            }
          }}
          disabled={disabled}>
          {header ? header(expand, canCollapse) : defaultHeader}
        </HeaderContainer>
      )}
      {(expand || !canCollapse) && <View style={{ flex: 1 }}>{children && children}</View>}
      {!canCollapse && header && header(expand, canCollapse)}
    </Container>
  );
};

const Container = styled.View<{ expanded: boolean; canCollapse: boolean }>`
  flex-shrink: 0;
  flex-direction: ${(props) => (props.canCollapse ? 'column' : 'row')};
  background-color: #fff;
  margin: 7px 0px;
  padding: ${(props) => (props.canCollapse ? '20px 0px 20px' : '0px')};
  border-radius: 4px;
`;

const HeaderContainer = styled(PressableWithOpacity)`
  flex-direction: row !important;
  align-items: center;
`;

const View = styled.View`
  padding: 10px 20px;
  display: block !important;
`;

const ExpandIcon = styled(Icon)`
  margin-right: 20px;
`;
